import '../styles.scss'
import React, { useState, useRef, useCallback } from 'react'
import 'react-html5-camera-photo/build/css/index.css'
import Modal from '../../Modals'
import { Button } from 'reactstrap'
import Webcam from 'react-webcam'
import { I18n } from 'react-redux-i18n'
import ImagePreview from './ImagePreview'
import { getStaticImage } from 'utils/statics'

// eslint-disable-next-line react/display-name
export default ({ showCamera, onCloseModal, sendData }) => {
  const [dataUri, setDataUri] = useState('')
  const [files, setFiles] = useState(null)

  const onToggleCamera = () => {
    setDataUri('')
    onCloseModal(false)
  }

  const webcamRef = useRef(null)

  const capture = useCallback(() => {
    setDataUri(webcamRef.current.getScreenshot())

    let arr = webcamRef.current.getScreenshot().split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while(n--){
      u8arr[n] = bstr.charCodeAt(n)
    }
    setFiles(new File([u8arr], 'capture.jpeg', { type:mime }))
  }, [webcamRef])

  const options = {
    width: 768,
    height: 432,
    imageSmoothing: true,
    mirrored: true,
    audio: false,
    screenshotFormat: 'image/jpeg',
    videoConstraints: {
      width: 1280,
      height: 720,
      facingMode: 'user',
    },
  }

  const switchCamera = async () => {
    const listOfVideoInputs = await getListOfVideoInputs()

    if (listOfVideoInputs.length > 1) {
      if (this.player.srcObject) {
        this.player.srcObject.getVideoTracks().forEach((track) => {
          track.stop()
        })
      }

      if (this.cameraNumber === 0) {
        this.cameraNumber = 1
      } else if (this.cameraNumber === 1) {
        this.cameraNumber = 0
      }

      this.initializeMedia()
    }
  }

  const getListOfVideoInputs = async () => {
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices()
    return enumerateDevices.filter((device) => device.kind === "videoinput")
  }

  return (
    <Modal
      isOpen={showCamera}
      toggle={onToggleCamera}
      contentClassName='modal-camera'
      backdrop={'static'}
      header={
        <div className='modal-wrapper-header'>
          <h1>{I18n.t('dashboard_capture-photo')}</h1>
          <span onClick={onToggleCamera}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
      }
      body={dataUri ? <ImagePreview dataUri={dataUri} isFullscreen={false} /> : <Webcam ref={webcamRef} {...options} />}
      footer={
        <div style={{ margin: 'auto' }}>
          {!dataUri ? (
            <>
              <Button color='primary' onClick={capture} className='button-camera'>
                <img src="https://assets.nixi1.dkv.es/chatweb/images/camera-white.svg" alt='icon' />
              </Button>
              {
                getListOfVideoInputs().length > 1 &&
                <Button color='primary' onClick={switchCamera} className='button-camera'>
                  <img src="https://assets.nixi1.dkv.es/chatweb/images/camera-rotate.svg" alt='icon' width='30px' />
                </Button>
              }
            </>
          ) : (
            <>
              <Button color='primary' onClick={() => {sendData(files); setDataUri('')}} className='button-camera'>
                <img src="https://assets.nixi1.dkv.es/chatweb/images/cloud-upload.svg" alt='icon'/>
              </Button>
              <Button color='primary' onClick={()=>setDataUri('')} className='button-camera'>
                <img src="https://assets.nixi1.dkv.es/chatweb/images/redo-alt-solid.svg" alt='icon'/>
              </Button>
            </>
          )}
        </div>
      }
    />
  )
}
